import { Outlet, Navigate } from 'react-router';
import Wrapper from '../templates/Wrapper';

export default function ({ isAdmin, to = '/events' }) {
  return isAdmin ? <Outlet /> : <Navigate to={to} replace />;
}
